import io from "socket.io-client";

export const websocket = io(process.env.REACT_APP_API_URL, {
  path: "/socket",
  transports: ["websocket"]
});
